import React from 'react';
import { createRoot } from 'react-dom/client';
import { parse as parseQuery, stringify as queryify } from 'qs';
import { omit } from 'lodash/fp';
import Root from './Root';
import {
  getCurrentUser,
  loginWithCurrentDetails,
  loginWithTemporaryToken,
  initialiseUser
} from './actions/userActions';
import configureStore from './store/configureStore';
import { isLoggedIn } from './api/auth';
import createDoubleClick from './thirdparty/doubleclick';
import razorpayCheckout from './thirdparty/razorpayCheckout';

const mountPoint = document.getElementById('fantasy');
const reactRoot = createRoot(mountPoint);

function main(store, history) {
  const { doubleClick } = store.getState().settings;
  const query = parseQuery(history.location.search, { ignoreQueryPrefix: true });

  if (doubleClick) {
    createDoubleClick(doubleClick);
  }

  if (process.env.APP_BRAND === 'india') {
    razorpayCheckout();
  }

  if (query.login_token) {
    store.dispatch(loginWithTemporaryToken(query.login_token));
    history.replace({
      pathname: history.pathname,
      search: queryify(omit('login_token', query), { addQueryPrefix: true })
    });
  } else if (isLoggedIn()) {
    store.dispatch(loginWithCurrentDetails());
  } else {
    store.dispatch(initialiseUser());
  }

  reactRoot.render(<Root history={history} store={store} />);

  if (module.hot) {
    let nextStore = store;
    module.hot.accept('./Root', () => {
      nextStore = configureStore(nextStore.getState());
      if (isLoggedIn()) {
        nextStore.dispatch(getCurrentUser());
      }

      const NextRoot = require('./Root').default; // eslint-disable-line global-require

      reactRoot.render(<NextRoot history={history} store={nextStore} />);
    });
  }
}

export default main;
